import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-clients',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clients.html',
  styleUrl: './clients.scss',
})
export class Clients {
  ts = inject(TranslationService);
  t = this.ts.t;

  clients = [
    'Vale', 'Petrobras', 'Gerdau', 'Embraer',
    'Suzano', 'Samarco', 'Usiminas', 'CSN',
    'Braskem', 'Votorantim', 'Anglo American', 'TIM'
  ];
}
